import * as React from 'react';
import * as style from '../../NewbuildingItem.css';
import { IconMapWalk16, IconMapCar16 } from '@cian/ui-kit-design-tokens/icons';
import { TTransportType } from '../../../../types/transportType';

interface IUndergroundTimeToProps {
  time?: string | null;
  transportType?: TTransportType | null;
}

export const UndergroundTimeTo: React.FC<IUndergroundTimeToProps> = ({ time, transportType }) => {
  if (!time) {
    return null;
  }

  const isWalk = transportType === 'walk';

  return (
    <div className={style['time']}>
      <span className={style['time-icon']}>{isWalk ? <IconMapWalk16 /> : <IconMapCar16 />}</span>
      <span className={style['time-text']}>{time}</span>
    </div>
  );
};
